var _defs, _rect, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 470,
    viewBox: "0 0 360 470",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gnight",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0f0c29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#302b63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#24243e"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 470,
    fill: "url(#gnight)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 80,
    r: 35,
    fill: "rgba(255,255,255,0.3)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "rgba(255,255,255,0.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 50,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 90,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 60,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 110,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 140,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 180,
    r: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 200,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 220,
    r: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNight);
export default __webpack_public_path__ + "static/media/night.9c90e015879fef3d4901945ee064ea00.svg";
export { ForwardRef as ReactComponent };